import NeverLandGameDataCommon from "./NeverLandGameDataCommon";

class NeverLandGameDataExpansion {
  _onChangedHandlers = [];
  defaultItems = [];

  getBasketItems() {
    return this._combinationItems;
  }

  _combinationItems = this.defaultItems // 모든 조합 리스트 = basketTicketList
  ticketData = [] // 선택된 것들을 카트 티켓 카드로 가공한 데이터
  prevTicketData = [] // 기존 카트에 담았던 데이터 백업 (새로 찾기 후 선택 시 새로운 티켓과 기존 티켓 병합할 때 사용)
  _toggledItemIds = new Set();  // 선택된 카드들의 ID 모음
  fixedSelectedAllotData = [];  // 고정경기 - 바구니에서는 사용 X

  refreshSelectItems() {
    // 티켓 데이터 생성 + 기존 데이터와 병합 + 정렬
    let _ticketData = [];

    // 새로 선택된 것들 생성
    _ticketData = this.createSelectedTicketData(_ticketData, this._combinationItems, this._toggledItemIds);
    let _ticketKeys = new Set();
    for (let ticket of _ticketData) {
      _ticketKeys.add(ticket.key);
    }
    NeverLandGameDataCommon.sortTicketData(_ticketData);

    let index = 0;
    // prevTicketData 있던 것들을 _ticketData 앞에 추가
    for (let ticket of this.prevTicketData) {
      if (_ticketKeys.has(ticket.key)) continue;
      _ticketData.splice(index++, 0, ticket);
    }
    _ticketKeys.clear();

    this.ticketData = _ticketData;
    this._onChanged();
  }

  removeTicket(ticketId) {
    // 카트사이드바에서 삭제 - ticketData 와 toggle 상태에서 모두 제거
    // ticketData 에서 제거
    this.ticketData = this.ticketData.filter((_card) => _card.id !== ticketId);
    // prevTicketData 에서도 제거
    this.prevTicketData = this.prevTicketData.filter((_card) => _card.id !== ticketId);
    // toggle (선택 상태)에서 제거
    this._toggledItemIds.delete(ticketId);

    this._onChanged();
  }


  getPredictionText(type, choice, allotTypeCategory) {
    // 화면 표시용 텍스트
    // SUM: "홀/짝"
    // UNDER_OVER: "언더/오버"
    // 기본: "승/무/패"
    const predictionMap = {
      SUM: {WIN: "홀", LOSE: "짝"},
      UNDER_OVER: {WIN: "언더", LOSE: "오버"}
    };

    let text = "";

    if (predictionMap[type]) {
      // 타입이 predictionMap 있으면 사용
      text = predictionMap[type][choice];
    } else {
      // 기본값 (승무패, 승5패, 승1패, 핸디)
      text = choice === "WIN" ? "승" : choice === "LOSE" ? "패" : "무";
    }
    // FIRST_HALF(전반)일 때 "(전)"붙이기
    if (allotTypeCategory === "FIRST_HALF") {
      return "(전)" + text;
    }

    return text;
  }

  getPredictionCode(choice) {
    // 출력 데이터용 텍스트
    if (choice === "WIN") return "승";
    if (choice === "LOSE") return "패";
    if (choice === "DRAW") return "무";
    return "무";
  }

  createSelectedTicketData(_ticketData, _combinationItems, _toggledItemIds) {
    // 원본 조합 데이터를 카트 표시용 티켓 카드 형식으로 변환
    let gameNumber = 'unknown';

    _combinationItems.map((ticket) => {
      if (this._toggledItemIds.has(ticket.id)) {
        let selectGame = [];
        let closingDate = "2999-12-32";

        for (let game of ticket.gameCombination) {
          let extraHomeText = '';
          let extraText = ''; // 'H', 'U', 'S'

          // 타입에 따라 경기번호앞에 H/U/S 붙이기 + 홈팀 옆에 extra text 붙이기
          if (game.type === 'HANDICAP') {
            extraText = 'H';
            extraHomeText = ' ' + game.extra;
          } else if (game.type === 'UNDER_OVER') {
            extraText = 'U ';
            extraHomeText = ' ' + game.extra;
          } else if (game.type === 'SUM') {
            extraText = 'S';
            extraHomeText = '';
          }

          if (gameNumber === 'unknown') {
            gameNumber = game.dataId.split('_')[2].substr(-3);
          }
          let itemKey = ticket.id + '_' + game.dataId;
          let itemGameNo = String(game.gameNo);

          let currentAllotData = {
            closingDate: game.gameDateTime.replace('T', ' '),
            itemKey: itemKey,
            isSingle: itemGameNo.includes('*'),
            allotId: game.allotId,
            category: game.category,
            gameNumber: extraText + itemGameNo.replace(/'*'/g, ''),
            homeTeam: game.homeTeam + extraHomeText,
            awayTeam: game.awayTeam,
            prediction: this.getPredictionText(game.type, game.choice, game.allotTypeCategory),
            predictionCode: this.getPredictionCode(game.choice),
            rate: game.value
          };

          if (closingDate > currentAllotData.closingDate) {
            closingDate = currentAllotData.closingDate;
          }

          selectGame.push(currentAllotData);
        }

        _ticketData.push({
          key: ticket.id + "&" + ticket.totalRate + "&" + selectGame.length,
          id: ticket.id,
          number: gameNumber,
          closingDate: closingDate,
          selectGame: [...selectGame],
          totalRate: ticket.finalResult
        });
      }
    });
    return _ticketData;
  }

  toggleSelectItem(id) {
    // 카드 선택/해제 토글
    if (this._toggledItemIds.has(id)) {
      this._toggledItemIds.delete(id)
    } else {
      this._toggledItemIds.add(id)
    }
    this.refreshSelectItems();
  }

  selectItemAll() {
    // 모든 카드 선택 (전체 선택)
    this.getBasketItems().map((ticket) => {
      if (!this._toggledItemIds.has(ticket.id)) {
        this._toggledItemIds.add(ticket.id)
      }
    });
    this.refreshSelectItems();
  }

  removeItemFromList(id) {
    // ticketList 에서 제거
    this._combinationItems = this._combinationItems.filter(item => item.id !== id);
    this._toggledItemIds.delete(id)
    console.log("this._combinationItems->", this._combinationItems)
    this.refreshSelectItems();
  }

  isSelected(id) {
    return this._toggledItemIds.has(id);
  }

  addOnChangedHandler(handler) {
    if (this._onChangedHandlers.includes(handler)) {
      return;
    }
    this._onChangedHandlers.push(handler);
  }

  removeOnChangedHandler(handler) {
    this._onChangedHandlers = this._onChangedHandlers.filter(h => h !== handler);
  }

  _onChanged() {
    try {
      this._onChangedHandlers.forEach(handler => {
        try {
          if (handler == null)
            return;
          handler();
        } catch {
        }
      });
    } catch {
    }
  }

  updateList(list) {
    this.prevTicketData = this.ticketData;
    this._combinationItems = list;
    return list;
  }

  clearSelection() {
    this._toggledItemIds.clear();
    this.prevTicketData = [];
    this.refreshSelectItems();
  }

}

const neverLandGameDataExpansion = new NeverLandGameDataExpansion();
export default neverLandGameDataExpansion;